// tracking library to use to call the forms
declare let ACMVisitor: any;

export default class SEOUtils {
  /**
   * Add the parameters from ACMVisitor if the ACMVisitor is defined
   * @param {string} url
   * @returns {string}
   */
  static addACMTrackerToUrl(url: string): string {
    if (typeof ACMVisitor === "undefined") {
      return url;
    }

    let newUrl = url;

    newUrl = this.addOrSetUrlParameter(newUrl, "trackPageId", ACMVisitor.trackPageId);
    newUrl = this.addOrSetUrlParameter(newUrl, "cookieId", ACMVisitor.cookieId);
    newUrl = this.addOrSetUrlParameter(newUrl, "sessionId", ACMVisitor.sessionId);

    return newUrl;
  }

  /**
   * Add the parameters from settings.sqcomSEO to the URL, if defined
   * @param {string} url
   * @returns {string}
   */
  static addSqcomSEOSettingsToUrl(url: string): string {
    // The tracking cookies are stored in the cookies and are prefixed with 'sq.tracking.'
    const rawCookies = document.cookie.split(";");
    let newUrl = url;

    for (const rawCookie of rawCookies) {
      if (rawCookie.trim().startsWith("sq.tracking.")) {
        const [parameter, value] = rawCookie
          .trim()
          .replace("sq.tracking.", "")
          .split("=");

        newUrl = this.addOrSetUrlParameter(newUrl, parameter, value);
      }
    }

    return newUrl;
  }

  /**
   * Add every required tracking parameters to the URL
   * @param url
   */
  static addUrlParameters(url: string): string {
    return SEOUtils.addACMTrackerToUrl(SEOUtils.addSqcomSEOSettingsToUrl(url));
  }

  /**
   * Add the given parameter to the URL or replace it with the given value
   * @param url
   * @param parameter
   * @param value
   */
  private static addOrSetUrlParameter(url: string, parameter: string, value: string): string {
    const parsed = new URL(url);

    parsed.searchParams.set(parameter, value);

    return parsed.toString();
  }
}
